/**
 * Skin Assessment Test (SAT) Utility Functions
 * Single source of truth for shared SAT functionality
 */

/**
 * Get Time label from index
 * @param {number} index - Time index (0=Day, 1=Night, 2=Both)
 * @returns {string|null} - Human readable time label or null if invalid
 */
function getTimeLabel(index) {
  switch (index) {
    case 0:
      return "Use it During Day";
    case 1:
      return "Use it During Night";
    case 2:
      return "For Day & Night";
    default:
      return null;
  }
};

window.getTimeLabel = getTimeLabel;
